import { Heading, Box, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { useWhoisMobileOptimizations } from '../../../../hooks/useWhoisMobileOptimizations';
import { InfoRow } from './InfoRow';
import s from '../whoisResultsPage.scss';
export const RegistrarSection = _ref => {
  let registrar = _ref.registrar,
    whoisBiParams = _ref.whoisBiParams;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const mobileOptimizations = useWhoisMobileOptimizations();
  const hasData = registrar.name || registrar.url || registrar.whoisServer;
  if (!hasData) {
    return null;
  }
  const onReferralClick = () => {
    if (!whoisBiParams) {
      return;
    }
    DomainSearchGateModule.internals.bi.onWhoisGeneralAction == null || DomainSearchGateModule.internals.bi.onWhoisGeneralAction({
      ...whoisBiParams,
      action: 'redirect',
      value: registrar.url,
      button_name: 'registrar information'
    });
  };
  const rows = [registrar.name && {
    key: 'name',
    label: t('domain_search_gate.whois_results.info_card.registrar_info.registrar_name.label'),
    value: registrar.name
  }, registrar.url && {
    key: 'url',
    label: t('domain_search_gate.whois_results.info_card.registrar_info.referral_url.label'),
    // A Text link (not TextButton) so long URLs wrap: TextButton forces
    // white-space: nowrap and truncates. skin='primary' gives the Figma blue.
    value: mobileOptimizations ? /*#__PURE__*/React.createElement(Text, {
      size: "small",
      skin: "primary",
      tagName: "a",
      className: s.referralUrl,
      href: registrar.url,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onReferralClick
    }, registrar.url) : /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      as: "a",
      href: registrar.url,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onReferralClick
    }, registrar.url)
  }, registrar.whoisServer && {
    key: 'whois',
    label: t('domain_search_gate.whois_results.info_card.registrar_info.server.label'),
    value: registrar.whoisServer
  }].filter(Boolean);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.whois_results.info_card.registrar_info.title')), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, rows.map(row => /*#__PURE__*/React.createElement(InfoRow, {
    key: row.key,
    label: row.label,
    value: row.value
  }))));
};
//# sourceMappingURL=RegistrarSection.js.map